import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import accountReducer from "./accountReducer";
import xoxoCodeCampaignReducer from "./xoxoCodeCampaignReducer";
import bulkProcessReducer from "./bulkProcessReducer";
import reportReducer from "./reportReducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

const persistConfig = {
  key: "root",
  whitelist: [],
  storage,
};

const bulkProcessReducerConfig = {
  key: "bulkProcessReducer",
  storage,
  whitelist: ["bulkProcessStatus", "bulkProcessData"],
};

const rootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    accountReducer,
    xoxoCodeCampaignReducer,
    bulkProcessReducer: persistReducer(
      bulkProcessReducerConfig,
      bulkProcessReducer
    ),
    reportReducer,
  });

const persistedReducer = (history) =>
  persistReducer(persistConfig, rootReducer(history));

export default persistedReducer;
